export const introduce = {
  text: `### 使用方法
  + 该指标统计了短期持有者持有Coin的数量，我们可以发现，短期持有者通常在牛市末期买入，熊市卖出，可以很好的帮助我们判断市场热度。
  
  ### 指标原理
  + 我们统计了持有小于一个月的所有投资者的持币数量，从而帮助我们判断他们的支出模式及规律。`,
  height: 1350,
};
